import { styled, Typography } from '@mui/material';

export const BuyerProfileIncompleteContainer = styled('div')(({ theme }) => ({
  height: '50vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '0 10px 10px',
  },
}));

export const StyledDescriptionText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
}));
